import { createRouter, createWebHashHistory } from "vue-router";
import { getIsLogin } from "@/utils";

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SingleView/about.vue"),
  },
  {
    path: "/explain",
    name: "explain",
    component: () =>
      import(
        /* webpackChunkName: "explain" */ "../views/SingleView/explain.vue"
      ),
  },
  {
    path: "/policy",
    name: "policy",
    component: () =>
      import(/* webpackChunkName: "policy" */ "../views/SingleView/policy.vue"),
  },
  {
    path: "/help",
    name: "help",
    component: () =>
      import(/* webpackChunkName: "help" */ "../views/SingleView/help.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () =>
      import(
        /* webpackChunkName: "privacy" */ "../views/SingleView/privacy.vue"
      ),
  },
  {
    path: "/clause",
    name: "clause",
    component: () =>
      import(/* webpackChunkName: "clause" */ "../views/SingleView/clause.vue"),
  },
  {
    path: "/object",
    name: "object",
    component: () =>
      import(/* webpackChunkName: "object" */ "../views/SingleView/object.vue"),
  },
  {
    path: "/template",
    name: "template",
    component: () =>
      import(
        /* webpackChunkName: "template" */ "../views/SingleView/template.vue"
      ),
  },
  {
    path: "/caseBase/:type",
    name: "caseBase",
    component: () =>
      import(/* webpackChunkName: "caseBase" */ "../views/CaseBaseView.vue"),
  },
  {
    path: "/caseBaseDetails/:id",
    name: "caseBaseDetails",
    component: () =>
      import(
        /* webpackChunkName: "caseBaseDetails" */ "../views/CaseBaseDetailsView.vue"
      ),
  },
  {
    path: "/user",
    name: "user",
    component: () =>
      import(/* webpackChunkName: "user" */ "../views/UserView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/user-information",
    name: "userInformation",
    component: () =>
      import(
        /* webpackChunkName: "userInformation" */ "../views/UserInformation.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/user-account",
    name: "userAccount",
    component: () =>
      import(/* webpackChunkName: "userAccount" */ "../views/UserAccount.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/user-earnings",
    name: "userEarnings",
    component: () =>
      import(
        /* webpackChunkName: "userEarnings" */ "../views/UserEarnings.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/user-contract",
    name: "userContract",
    component: () =>
      import(
        /* webpackChunkName: "userContract" */ "../views/UserContract.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/user-message",
    name: "userMessage",
    component: () =>
      import(/* webpackChunkName: "userMessage" */ "../views/UserMessage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/user-publish/:type",
    name: "userPublish",
    component: () =>
      import(
        /* webpackChunkName: "userPublish" */ "../views/UserPublish/index.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/upload-case/:type/:from/:id/:track?", // type是普通还是优秀，form是从发布里面的哪里来的，id是案例的id
    name: "uploadCase",
    component: () =>
      import(
        /* webpackChunkName: "userUploadCase" */ "../views/UserPublish/UploadCaseView.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/search/:config",
    name: "search",
    component: () =>
      import(/* webpackChunkName: "search" */ "../views/SearchView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
  },
  {
    path: "/signIn",
    name: "signIn",
    component: () =>
      import(/* webpackChunkName: "signIn" */ "../views/SignInView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLogin = getIsLogin();
  if (to.meta?.requiresAuth) {
    !isLogin ? next({ name: "login" }) : next();
  } else {
    next();
  }
});

export default router;
